export const EXCLUDE_DEFAULT_FILTER = ['Select', 'Actions', 'Origin IMPC(s)'];
